<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-popup dialog-content">
    <v-carousel hide-delimiters height="306" v-model="slideNumber">
      <v-carousel-item v-for="(item, i) in items" :key="i">
        <v-row class="com-popup-header" justify="center">
          <span class="com-popup-title">{{ item.name }}</span>
          <v-spacer></v-spacer>
          <v-btn icon x-small @click="closeLegend">
            <v-icon color="white">highlight_off</v-icon>
          </v-btn>
        </v-row>
        <v-row
          no-gutters
          class="com-popup-contents"
          justify="center"
          align-content="center"
        >
          <legend-radar v-if="item.key == 'radar'"></legend-radar>
          <legend-tm-knd v-else-if="item.key == 'tm'"></legend-tm-knd>
          <legend-tm-stg v-else-if="item.key == 'tm_stg'"></legend-tm-stg>
          <legend-tm-swstg v-else-if="item.key == 'tm_swstg'"></legend-tm-swstg>
          <legend-tm-qwtr v-else-if="item.key == 'tm_qwtr'"></legend-tm-qwtr>
          <legend-tm-coast v-else-if="item.key == 'tm_coast'"></legend-tm-coast>
          <legend-tm-snw v-else-if="item.key == 'tm_snw'"></legend-tm-snw>
          <legend-fldfr v-else-if="item.key == 'fldfr'"></legend-fldfr>
          <legend-damdsch v-else-if="item.key == 'damdsch'"></legend-damdsch>
          <legend-fldctl v-else-if="item.key == 'fldctl'"></legend-fldctl>
          <legend-location v-else-if="item.key == 'location'"></legend-location>
        </v-row>
      </v-carousel-item>
    </v-carousel>
    <div class="serial-num">{{ serialNum }}</div>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
import LegendRadar from "./legend/LegendRadar";
import LegendTmKnd from "./legend/LegendTmKnd";
import LegendTmStg from "./legend/LegendTmStg";
import LegendTmSwstg from "./legend/LegendTmSwstg";
import LegendTmQwtr from "./legend/LegendTmQwtr";
import LegendTmCoast from "./legend/LegendTmCoast";
import LegendTmSnw from "./legend/LegendTmSnw";
import LegendFldfr from "./legend/LegendFldfr";
import LegendDamdsch from "./legend/LegendDamdsch";
import LegendFldctl from "./legend/LegendFldctl";
import LegendLocation from "./legend/LegendLocation";

/**
 * 川の防災情報 地図画面 地図凡例ダイアログ
 * Legend.vue
 * @author LIS
 */
export default {
  name: "map-legend",
  /** コンポーネント */
  components: {
    LegendRadar,
    LegendTmKnd,
    LegendTmStg,
    LegendTmSwstg,
    LegendTmQwtr,
    LegendTmCoast,
    LegendTmSnw,
    LegendFldfr,
    LegendDamdsch,
    LegendFldctl,
    LegendLocation,
  },
  data() {
    return {
      /** 文字列リソース */
      itemResource: [
        {
          key: "radar",
          name: "レーダ雨量",
        },
        {
          key: "tm",
          name: "観測所種別",
        },
        {
          key: "tm_stg",
          name: "水位観測",
        },
        {
          key: "tm_swstg",
          name: this.$store.state.app.config.replaceNameConfig.swstg,
        },
        {
          key: "tm_qwtr",
          name: "水質",
        },
        {
          key: "tm_coast",
          name: "海岸",
        },
        {
          key: "tm_snw",
          name: "積雪深",
        },
        {
          key: "fldfr",
          name: "洪水予報等",
        },
        {
          key: "damdsch",
          name: "ダム放流状況",
        },
        {
          key: "fldctl",
          name: "水防警報",
        },
        {
          key: "location",
          name: "現在位置・登録地点",
        },
      ],
      /** 凡例リスト */
      items: [],
      /** 凡例リスト（一般用） */
      generalItems: [],
      /** 凡例リスト（水防団用） */
      floodItems: [],
      /** 凡例スライド番号 */
      slideNumber: 0,
    };
  },
  mounted() {
    /** 凡例リスト（一般用・水防団用）に初期値を設定 */
    this.init();
  },
  computed: {
    /** 表示コンテンツ取得 */
    getContent: {
      get() {
        return this.$store.state.app.content;
      },
    },
    /** 地図凡例ダイアログ表示取得 */
    getShowLegend: {
      get() {
        return this.$store.state.map.showLegend;
      },
    },
    /** 遠し番号文字 */
    serialNum: {
      get() {
        let num = this.slideNumber + 1;
        let total = this.items.length;
        return String(num) + "/" + String(total);
      },
    },
  },
  methods: {
    /** 地図凡例ダイアログの非表示 */
    closeLegend() {
      this.$store.commit("map/setShowLegend", false);
    },
    /** スライドのデフォルト選択制御 */
    defaultSlideOption() {
      let selectItem = null;
      if (this.getContent === "Radar") {
        selectItem = this.items.find((item) => {
          return item.key === "radar";
        });
      } else if (this.getContent === "TmList") {
        selectItem = this.items.find((item) => {
          return item.key === "tm_stg";
        });
      } else if (this.getContent === "RiverwarnList") {
        selectItem = this.items.find((item) => {
          return item.key === "fldfr";
        });
      } else if (this.getContent === "RegistPoint") {
        selectItem = this.items.find((item) => {
          return item.key === "location";
        });
      }

      if (selectItem) {
        this.slideNumber = this.items.indexOf(selectItem);
      }
    },
    init() {
      /** 凡例リスト（一般用）に初期値を設定 */
      this.generalItems = [
        {
          key: this.itemResource[1].key,
          name: this.itemResource[1].name,
        },
        {
          key: this.itemResource[2].key,
          name: this.itemResource[2].name,
        },
        {
          key: this.itemResource[3].key,
          name: this.itemResource[3].name,
        },
        {
          key: this.itemResource[4].key,
          name: this.itemResource[4].name,
        },
        {
          key: this.itemResource[5].key,
          name: this.itemResource[5].name,
        },
        {
          key: this.itemResource[6].key,
          name: this.itemResource[6].name,
        },
        {
          key: this.itemResource[7].key,
          name: this.itemResource[7].name,
        },
        {
          key: this.itemResource[8].key,
          name: this.itemResource[8].name,
        },
        {
          key: this.itemResource[10].key,
          name: this.itemResource[10].name,
        },
        {
          key: this.itemResource[0].key,
          name: this.itemResource[0].name,
        },
      ];
      /** 凡例リスト（水防団用）に初期値を設定 */
      this.floodItems = [
        {
          key: this.itemResource[1].key,
          name: this.itemResource[1].name,
        },
        {
          key: this.itemResource[2].key,
          name: this.itemResource[2].name,
        },
        {
          key: this.itemResource[3].key,
          name: this.itemResource[3].name,
        },
        {
          key: this.itemResource[4].key,
          name: this.itemResource[4].name,
        },
        {
          key: this.itemResource[5].key,
          name: this.itemResource[5].name,
        },
        {
          key: this.itemResource[6].key,
          name: this.itemResource[6].name,
        },
        {
          key: this.itemResource[7].key,
          name: this.itemResource[7].name,
        },
        {
          key: this.itemResource[8].key,
          name: this.itemResource[8].name,
        },
        {
          key: this.itemResource[9].key,
          name: this.itemResource[9].name,
        },
        {
          key: this.itemResource[10].key,
          name: this.itemResource[10].name,
        },
        {
          key: this.itemResource[0].key,
          name: this.itemResource[0].name,
        },
      ];
    },
  },
  watch: {
    /** 表示コンテンツ監視 */
    getContent() {
      this.defaultSlideOption();
    },
    /** 地図凡例ダイアログ表示監視 */
    getShowLegend() {
      // 水防団用表示の場合
      if (this.$store.getters["app/isFldCtl"]) {
        this.items = this.floodItems;
      }
      // 一般用表示の場合
      else {
        this.items = this.generalItems;
      }

      this.defaultSlideOption();
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.dialog-content {
  position: absolute;
  z-index: 3050;
  bottom: 4px;
  right: 4px;
  width: 250px;
}
.serial-num {
  text-align: center;
  font-size: 1rem;
}
</style>
